var map;
var infoWindow;
var markers = {};

var svgString = `<?xml version="1.0" encoding="iso-8859-1"?><svg height="800px" width="800px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 293.334 293.334" xml:space="preserve"><g><g><path style="fill:#000000;" d="M146.667,0C94.903,0,52.946,41.957,52.946,93.721c0,22.322,7.849,42.789,20.891,58.878c4.204,5.178,11.237,13.331,14.903,18.906c21.109,32.069,48.19,78.643,56.082,116.864c1.354,6.527,2.986,6.641,4.743,0.212c5.629-20.609,20.228-65.639,50.377-112.757c3.595-5.619,10.884-13.483,15.409-18.379c6.554-7.098,12.009-15.224,16.154-24.084c5.651-12.086,8.882-25.466,8.882-39.629C240.387,41.962,198.43,0,146.667,0z M146.667,144.358c-28.892,0-52.313-23.421-52.313-52.313c0-28.887,23.421-52.307,52.313-52.307s52.313,23.421,52.313,52.307C198.98,120.938,175.559,144.358,146.667,144.358z"/><circle style="fill:#000000;" cx="146.667" cy="90.196" r="21.756"/></g></g></svg>`;

// Your Google My Maps ID
const MY_MAP_ID = '1yFmxiTEBAStM0KEnbfVsuoxjMn5hUqdU';

function initMap() {
  map = new google.maps.Map(document.getElementById("show-map"), {
    zoom: 5,
    center: { lat: 37.0902, lng: -95.7129 },
    streetViewControl: false,
    mapTypeControl: false,
    zoomControl: true,
    scaleControl: true,
    rotateControl: false,
    styles: [
      {
        featureType: "all",
        elementType: "all",
        stylers: [{ visibility: "on" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#444444" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f2f2f2" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: -100 }, { lightness: 45 }],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#dfdfdf" }, { visibility: "on" }],
      },
    ],
  });

  infoWindow = new google.maps.InfoWindow();

  const urlParams = new URLSearchParams(window.location.search);
  const dealerSlug = urlParams.get("dealer");
  
  // Load data from Google My Maps
  // Temporarily using fallback data for testing
  console.log('Using fallback data for testing');
  //renderMapPoints(originalData, dealerSlug);
  
  // Uncomment the line below to try Google My Maps integration
   loadMyMapsData(dealerSlug);
}

async function loadMyMapsData(dealerSlug) {
  console.log('Attempting to load My Maps data...');
  
  try {
    // Method 1: Try using Google Maps JavaScript API with Fusion Tables (if available)
    // Method 2: Try direct KML import to Google Maps
    const kmlUrl = `https://www.google.com/maps/d/kml?mid=${MY_MAP_ID}&forcekml=1`;
    
    console.log('Trying KML URL:', kmlUrl);
    
    // Create a KML layer directly on the map
    const kmlLayer = new google.maps.KmlLayer({
      url: kmlUrl,
      map: map,
      suppressInfoWindows: false
    });
    
    // Wait for the KML layer to load
    google.maps.event.addListener(kmlLayer, 'status_changed', function() {
      console.log('KML Layer status:', kmlLayer.getStatus());
      
      if (kmlLayer.getStatus() === google.maps.KmlLayerStatus.OK) {
        console.log('KML Layer loaded successfully!');
        // Hide the KML layer and extract data manually
        kmlLayer.setMap(null);
        
        // Try to fetch the KML data for custom rendering
        fetchKMLDataForCustomRendering(dealerSlug);
      } else {
        console.log('KML Layer failed to load, using fallback data');
        renderMapPoints(originalData, dealerSlug);
      }
    });
    
  } catch (error) {
    console.error('Error loading My Maps data:', error);
    console.log('Falling back to hardcoded data');
    
    // Fallback: Use the original hardcoded data
    renderMapPoints(originalData, dealerSlug);
  }
}

async function fetchKMLDataForCustomRendering(dealerSlug) {
  try {
    // Try multiple methods to get the KML data
    const urls = [
      `https://www.google.com/maps/d/kml?mid=${MY_MAP_ID}&forcekml=1`,
      `https://www.google.com/maps/d/kml?mid=${MY_MAP_ID}`,
      `https://drive.google.com/uc?export=download&id=${MY_MAP_ID}`
    ];
    
    for (const url of urls) {
      try {
        console.log('Trying URL:', url);
        const response = await fetch(url);
        
        if (response.ok) {
          const kmlText = await response.text();
          console.log('KML data received, length:', kmlText.length);
          
          if (kmlText.includes('Placemark')) {
            const data = parseKMLData(kmlText);
            if (data.features.length > 0) {
              renderMapPoints(data, dealerSlug);
              return;
            }
          }
        }
      } catch (fetchError) {
        console.log('Failed to fetch from:', url, fetchError.message);
      }
    }
    
    throw new Error('All KML fetch methods failed');
    
  } catch (error) {
    console.error('Error in custom KML rendering:', error);
    renderMapPoints(originalData, dealerSlug);
  }
}

function parseKMLData(kmlText) {
  const parser = new DOMParser();
  const kmlDoc = parser.parseFromString(kmlText, 'text/xml');
  const placemarks = kmlDoc.querySelectorAll('Placemark');
  
  console.log('Found placemarks:', placemarks.length);
  
  const features = [];
  placemarks.forEach((placemark, index) => {
    const name = placemark.querySelector('name')?.textContent || `Location ${index + 1}`;
    const description = placemark.querySelector('description')?.textContent || '';
    const coordinates = placemark.querySelector('coordinates')?.textContent;
    
    console.log(`Placemark ${index}:`, { name, coordinates });
    
    if (coordinates) {
      const coordArray = coordinates.trim().split(',');
      const lng = parseFloat(coordArray[0]);
      const lat = parseFloat(coordArray[1]);
      
      if (!isNaN(lat) && !isNaN(lng)) {
        features.push({
          type: "Feature",
          geometry: { type: "Point", coordinates: [lat, lng] },
          properties: {
            id: index + 1,
            name: name,
            description: description,
            dealerId: 1,
            color: "#d5c89c",
          },
        });
        console.log(`Added feature: ${name} at ${lat}, ${lng}`);
      }
    }
  });
  
  console.log('Total features created:', features.length);
  
  return {
    type: "FeatureCollection",
    features: features
  };
}

function renderMapPoints(data, dealerSlug) {
  // Remove old markers
  Object.keys(markers).forEach((markerId) => {
    markers[markerId].setMap(null);
    delete markers[markerId];
  });

  // Filter by dealer ID if provided
  const filteredFeatures =
    dealerSlug && dealerSlug !== "all"
      ? data.features.filter(
          (feature) => feature.properties.dealerId == dealerSlug
        )
      : data.features;

  filteredFeatures.forEach(function (feature) {
    const coords = feature.geometry.coordinates;
    const properties = feature.properties;

    var coloredSvgString = svgString.replace(
      /fill:#000000;/g,
      `fill:${properties.color};`
    );

    const marker = new google.maps.Marker({
      position: new google.maps.LatLng(coords[0], coords[1]),
      map: map,
      title: properties.name,
      icon: {
        url:
          "data:image/svg+xml;charset=UTF-8;base64," +
          btoa(unescape(encodeURIComponent(coloredSvgString))),
        scaledSize: new google.maps.Size(36, 36),
      },
      customInfo: properties,
    });

    google.maps.event.addListener(marker, "click", function () {
      showInfoWindow(marker.customInfo, marker);
    });

    markers[properties.id] = marker;
  });
}

function showInfoWindow(customInfo, marker) {
  var pointName = customInfo.name;
  var pointDescription = customInfo.description;
  var locName = "<p><strong>" + pointName + "</strong></p>";
  var locDescrip = "<p>" + pointDescription + "</p>";
  var contentWrapper =
    "<div class='infoWindowContent'>" + locName + locDescrip + "</div>";
  infoWindow.setContent(contentWrapper);
  infoWindow.setPosition(marker.getPosition());
  infoWindow.setOptions({ pixelOffset: new google.maps.Size(0, -30) });
  infoWindow.open(map);
}

document.addEventListener("DOMContentLoaded", function () {
  // Only initialize if we're using the custom map (not the iframe version)
  if (document.getElementById("show-map") && !document.querySelector('iframe')) {
    initMap();

    const links = document.querySelectorAll("#side_bar ul li a");
    links.forEach((link) => {
      link.addEventListener("click", function (event) {
        event.preventDefault();
        const dealerSlug = this.getAttribute("data-dealer");
        window.history.pushState({}, "", `?dealer=${dealerSlug}`);
        loadMyMapsData(dealerSlug);
      });
    });
  }
});

// Original hardcoded data as fallback
const originalData = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [29.2582662, -98.2076608] },
      properties: {
        id: 44,
        name: "Albert Casanova",
        description: '<p>Albert Casanova<br>618 Cherry Ridge<br>Floresville, TX 78114<br>United States<br><a href="http://www.casanovashomes.com">http://www.casanovashomes.com</a><br><a href="tel:(830) 216-4357">(830) 216-4357</a><br><a href="mailto:casanovashms1@aol.com">casanovashms1@aol.com</a></p>',
        dealerId: 1,
        color: "#d5c89c",
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [32.1460342, -90.8894841] },
      properties: {
        id: 63,
        name: "Albert Gullett",
        description: '<p>Albert Gullett<br>960 Gullett Road<br>Vicksburg, MS 39180<br>United States<br><a href="tel:(601) 529-4820">(601) 529-4820</a></p>',
        dealerId: 1,
        color: "#d5c89c",
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [35.0954177, -77.0839556] },
      properties: {
        id: 127,
        name: "Andy Bayliss",
        description: '<p>Andy Bayliss<br>2851 Trent Road<br>New Bern, NC 28562<br>United States<br><a href="http://www.tabpremiumbuilthomes.com">http://www.tabpremiumbuilthome...</a><br><a href="tel:(252) 638-8310">(252) 638-8310</a><br><a href="mailto:andy@tabpremiumbuilthomes.com">andy@tabpremiumbuilthomes.com</a></p>',
        dealerId: 1,
        color: "#d5c89c",
      },
    }
    // Add more locations from your original data as needed
  ],
};
